let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6wZ1b")).then(() => parcelRequire('4n6tJ'));